import { Fragment, PureComponent } from 'react';
import BootstrapPagination from 'react-bootstrap/lib/Pagination';
import mapProps from 'map-props';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cns from 'classnames';

import ChevronLeftIcon from 'components/icons/ChevronLeftIcon.com.svg';
import ChevronRightIcon from 'components/icons/ChevronRightIcon.com.svg';
import Item from './Item';
import propsMapping from './propsMapping';

import cn from './styles.local.less';

class Pagination extends PureComponent {
  static propTypes = {
    activePage: PropTypes.number.isRequired,
    items: PropTypes.number.isRequired,
    loadPage: PropTypes.func.isRequired,
  };

  handleSelect = (page) => {
    const { activePage, loadPage } = this.props;

    if (page !== activePage) {
      loadPage(page).then(() => window.scrollTo(0, 0));
    }
  };

  render() {
    const { activePage, items } = this.props;

    if (!items) {
      return null;
    }

    const next = (
      <Fragment>
        {__('search.pagination.next')}
        <ChevronRightIcon className={cn.icon} />
      </Fragment>
    );

    const prev = (
      <Fragment>
        <ChevronLeftIcon className={cn.icon} />
        {__('search.pagination.previous')}
      </Fragment>
    );

    return (
      <Fragment>
        <BootstrapPagination
          activePage={activePage}
          buttonComponentClass={Item}
          className={cns(cn.pagination, 'visible-xs-block')}
          ellipsis={false}
          items={items}
          maxButtons={4}
          next={next}
          onSelect={this.handleSelect}
          prev={prev}
        />

        <BootstrapPagination
          activePage={activePage}
          boundaryLinks
          buttonComponentClass={Item}
          className={cns(cn.pagination, 'hidden-xs')}
          ellipsis
          items={items}
          maxButtons={5}
          next={next}
          onSelect={this.handleSelect}
          prev={prev}
        />
      </Fragment>
    );
  }
}

export default withRouter(mapProps(propsMapping)(Pagination));
